import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("button", {
        class: "dark:text-red-400 text-cyan-200",
        onClick: _cache[0] || (_cache[0] =
            //@ts-ignore
            (...args) => (_ctx.toggleTheme && _ctx.toggleTheme(...args)))
    }, "\n      Theme Toggle\n    "));
}
